var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import CollectionCaseInfo from "~/components/collection-execution/collection-case-info.vue";
import CollectionAddList from "~/components/collection-execution/collection-add-list.vue";
import CaseCollectionState from "~/components/collection-execution/case-collection-state.vue";
import CollectionActionArea from "~/components/collection-execution/collection-action-area.vue";
import CollectionHistoryInfo from "~/components/collection-execution/collection-history-info.vue";
import CollectionHotkey from "~/components/collection-execution/collection-hotkey.vue";
import DoyanPhone from "~/components/collection-execution/doyan-phone.vue";
import PendingCollectionQuery from "~/components/collection-execution/pending-collection-query.vue";
import SpeechContent from "~/components/collection-execution/collection-speech/speech-content.vue";
import { Watch, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { DataImportExcelInfoService } from "~/services/dataimp-service/data-import-excel-info.service";
import { MENU_CHANNEL } from "~/config/enum.config";
import CustomerInfo from "~/components/collection-execution/case-base-info/customer-info.vue";
var CollectionExecutionModule = namespace("collection-execution");
var workspaceModule = namespace("workspace");
var CollectionExecution = /** @class */ (function (_super) {
    __extends(CollectionExecution, _super);
    function CollectionExecution() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.speechContent = false;
        _this.showCaseList = false;
        _this.hiddenActiontemp = false;
        _this.showCase = false;
        _this.legalRecordId = "";
        _this.topInfo = {
            caseNumber: "",
            commonDebtNum: 0,
            commonDebtAmt: 0,
            sex: "",
            personalName: "",
            age: "",
            marital: "",
            idCard: "",
            birthday: "",
            caseMoney: "",
            carFrameNo: ''
        };
        return _this;
    }
    Object.defineProperty(CollectionExecution.prototype, "isShowButton", {
        //协催执行页不显示左右快捷菜单
        get: function () {
            var disabledMenu = [MENU_CHANNEL.Assist_tel, MENU_CHANNEL.Assist_visit, MENU_CHANNEL.Assist_legal];
            return disabledMenu.includes(this.menuChannel);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 初始化
     */
    CollectionExecution.prototype.ready = function () {
        var _this = this;
        // 注册点击事件
        document.addEventListener("click", function (event) {
            var target = event.target;
            var hotKeyElement = document.getElementById("divHotKey");
            if (hotKeyElement && !hotKeyElement.contains(target)) {
                _this.showCaseList = false;
            }
        });
    };
    CollectionExecution.prototype.mounted = function () {
        this.hiddenActiontemp = this.hiddenAction;
        this.refreshData(this.caseId);
    };
    CollectionExecution.prototype.onCaseIdChange = function (caseId) {
        this.refreshData(caseId);
    };
    CollectionExecution.prototype.legalRecordChange = function () {
        var _this = this;
        if (this.legalRecordId && this.legalRecordId !== "") {
            this.hiddenActiontemp = !this.hiddenActiontemp;
            this.$nextTick(function () {
                _this.hiddenActiontemp = !_this.hiddenActiontemp;
            });
        }
    };
    CollectionExecution.prototype.refreshData = function (caseId) {
        switch (this.menuChannel) {
            case MENU_CHANNEL.Case_imported:
                this.getImportTopInfo();
                break;
            default:
                this.getNormalTopInfo();
                break;
        }
    };
    CollectionExecution.prototype.getImportTopInfo = function () {
        var _this = this;
        this.dataImportExcelInfoService
            .importTopInfo(this.caseId)
            .subscribe(function (data) {
            _this.dataParams(data);
            _this.topInfo.caseMoney = data.overdueAmount;
        });
    };
    CollectionExecution.prototype.getNormalTopInfo = function () {
        var _this = this;
        this.caseOperatorPageService.topInfo(this.caseId).subscribe(function (data) {
            _this.dataParams(data);
        });
    };
    CollectionExecution.prototype.dataParams = function (data) {
        this.topInfo = data;
        this.updateCaseNo(data.caseNumber);
        var strBirthday = data.idCard.substr(6, 4) +
            "-" +
            data.idCard.substr(10, 2) +
            "-" +
            data.idCard.substr(12, 2);
        this.topInfo.age =
            new Date().getFullYear() - new Date(strBirthday).getFullYear();
        this.topInfo.birthday = strBirthday;
    };
    Object.defineProperty(CollectionExecution.prototype, "hiddenRight", {
        get: function () {
            return this.menuChannel === MENU_CHANNEL.Case_imported || this.menuChannel === MENU_CHANNEL.Case_await;
        },
        enumerable: false,
        configurable: true
    });
    CollectionExecution.prototype.back = function () {
        this.$router.back();
        if (this.isMessageShow) {
            this.updateMessageBoxVisible(true);
            this.updatedIsMessageShow(false);
        }
    };
    CollectionExecution.prototype.disposeCase = function (id) {
        this.legalRecordId = id;
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], CollectionExecution.prototype, "caseOperatorPageService", void 0);
    __decorate([
        Dependencies(DataImportExcelInfoService)
    ], CollectionExecution.prototype, "dataImportExcelInfoService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CollectionExecution.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CollectionExecution.prototype, "hiddenCaseList", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CollectionExecution.prototype, "hiddenAction", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CollectionExecution.prototype, "hiddenCollectionStatus", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CollectionExecution.prototype, "menuChannel", void 0);
    __decorate([
        CollectionExecutionModule.Mutation
    ], CollectionExecution.prototype, "updateCaseNo", void 0);
    __decorate([
        workspaceModule.Mutation
    ], CollectionExecution.prototype, "updatedIsMessageShow", void 0);
    __decorate([
        workspaceModule.Mutation
    ], CollectionExecution.prototype, "updateMessageBoxVisible", void 0);
    __decorate([
        workspaceModule.State
    ], CollectionExecution.prototype, "isMessageShow", void 0);
    __decorate([
        Prop({ type: String })
    ], CollectionExecution.prototype, "debt", void 0);
    __decorate([
        Watch("caseId")
    ], CollectionExecution.prototype, "onCaseIdChange", null);
    __decorate([
        Watch('legalRecordId', { immediate: true })
    ], CollectionExecution.prototype, "legalRecordChange", null);
    CollectionExecution = __decorate([
        Component({
            components: {
                CollectionCaseInfo: CollectionCaseInfo,
                CollectionAddList: CollectionAddList,
                CollectionActionArea: CollectionActionArea,
                CollectionHistoryInfo: CollectionHistoryInfo,
                CollectionHotkey: CollectionHotkey,
                DoyanPhone: DoyanPhone,
                SpeechContent: SpeechContent,
                CustomerInfo: CustomerInfo,
                CaseCollectionState: CaseCollectionState,
                PendingCollectionQuery: PendingCollectionQuery
            }
        })
    ], CollectionExecution);
    return CollectionExecution;
}(Vue));
export default CollectionExecution;
